import { useState, useEffect } from 'react'

const AI_PLATFORMS = {
  CLAUDE: 'Claude',
  GROK: 'Grok',
  CHATGPT: 'ChatGPT',
  GEMINI: 'Gemini'
}

const detectPlatformFromReferrer = () => {
  if (typeof document === 'undefined') return null

  const referrer = document.referrer.toLowerCase()

  if (referrer.includes('claude.ai')) {
    return AI_PLATFORMS.CLAUDE
  } else if (referrer.includes('grok.com') || referrer.includes('x.com/i/grok')) {
    return AI_PLATFORMS.GROK
  } else if (referrer.includes('chat.openai.com') || referrer.includes('chatgpt.com')) {
    return AI_PLATFORMS.CHATGPT
  } else if (referrer.includes('gemini.google.com')) {
    return AI_PLATFORMS.GEMINI
  }

  return null
}

export const useAIPlatformSource = () => {
  const [platformSource, setPlatformSource] = useState(null)

  useEffect(() => {
    const storedPlatform = localStorage.getItem('ai-platform-source')

    if (storedPlatform) {
      setPlatformSource(storedPlatform)
    } else {
      const detectedPlatform = detectPlatformFromReferrer()

      if (detectedPlatform) {
        localStorage.setItem('ai-platform-source', detectedPlatform)
        setPlatformSource(detectedPlatform)
      }
    }
  }, [])

  return platformSource
}
